import { styled } from '@mui/material/styles';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import React, { PropsWithChildren } from 'react';
import { CloseIcon, ErrorIcon, InfoIcon, SuccessIcon } from '../Icon';

const IconPadding = styled('span')`
  margin-right: ${(props) => props.theme.spacing(1)};
  margin-top: ${(props) => props.theme.spacing(1)};
`;

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main
    }
  })
);

const StyledCloseIcon = styled(CloseIcon)`
  font-size: 16px;
`;

export function ToastProvider({ children }: PropsWithChildren<{}>) {
  const notistackRef = React.createRef<SnackbarProvider>();

  /**Dismiss Toast */
  function onClickDismiss(key: any) {
    //@ts-ignore
    notistackRef.current.closeSnackbar(key);
  }

  return (
    <SnackbarProvider
      action={(key) => <StyledCloseIcon onClick={() => onClickDismiss(key)} />}
      maxSnack={5}
      disableWindowBlurListener
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent
      }}
      iconVariant={{
        success: (
          <IconPadding data-cy="toast-success">
            <SuccessIcon sx={{ fontSize: '16px' }} />
          </IconPadding>
        ),
        error: (
          <IconPadding data-cy="toast-error">
            <ErrorIcon sx={{ fontSize: '16px' }} />
          </IconPadding>
        ),
        warning: (
          <IconPadding data-cy="toast-warning">
            <ErrorIcon sx={{ fontSize: '16px' }} />
          </IconPadding>
        ),
        info: (
          <IconPadding data-cy="toast-info">
            <InfoIcon sx={{ fontSize: '16px' }} />
          </IconPadding>
        )
      }}
      ref={notistackRef}
    >
      {children}
    </SnackbarProvider>
  );
}
